import { useFeatureFlag } from "hooks/UseFeatureFlag";
import { shouldUseAgentNextCallGroupFlow } from "services/AWUtilityService";

/** Statsig gate key evaluated by platform_backend via POST /feature-flags/{flag}/evaluate. */
export const AGWS_AGENT_NEXT_CALL_GROUP_FLAG = "agws_agent_next_call_group";

/**
 * Gate for the PGS-2168 agent next-call-group flow.
 *
 * Returns {@code [enabled, loading]} where {@code enabled} is true only when
 * flag {@code agws_agent_next_call_group} is on (evaluated on the backend) and
 * the user is not an AW admin. Admins always keep the existing Call Group List.
 */
export function useAgentNextCallGroupFlow() {
  const [flagEnabled, loading] = useFeatureFlag(AGWS_AGENT_NEXT_CALL_GROUP_FLAG);
  return [shouldUseAgentNextCallGroupFlow(flagEnabled), loading];
}
